import axios from "axios";

 const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: `${BASE_URL}/api`, // 👈 your Laravel API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
